 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"BDA Visit":"BDA Visit","Calendar~Pd Offer Form~Product Banner~Products~Target Upload~staff~user":"Calendar~Pd Offer Form~Product Banner~Products~Target Upload~staff~user","Calendar~Target Upload":"Calendar~Target Upload","Calendar":"Calendar","Target Upload":"Target Upload","PD Offers":"PD Offers","analytics":"analytics","BDA Visit Form~Pd Offer Form~Product Banner~Role~RoleForm~barcode-scan~complain~staff~user":"BDA Visit Form~Pd Offer Form~Product Banner~Role~RoleForm~barcode-scan~complain~staff~user","BDA Visit Form":"BDA Visit Form","Pd Offer Form~Product Banner~Products~staff~user":"Pd Offer Form~Product Banner~Products~staff~user","Pd Offer Form":"Pd Offer Form","Product Banner":"Product Banner","staff":"staff","user":"user","RoleForm":"RoleForm","Role":"Role","barcode-scan":"barcode-scan","complain":"complain","Products":"Products","login":"login","setting":"setting"}[chunkId]||chunkId) + "." + {"BDA Visit":"007d2a51","Calendar~Pd Offer Form~Product Banner~Products~Target Upload~staff~user":"1464dc54","Calendar~Target Upload":"90d2dd78","Calendar":"14cde728","Target Upload":"38f1a25e","PD Offers":"e4af9bd2","analytics":"68d7aeee","chunk-2d0e97b4":"1877b7cb","BDA Visit Form~Pd Offer Form~Product Banner~Role~RoleForm~barcode-scan~complain~staff~user":"5f200794","BDA Visit Form":"346cda35","Pd Offer Form~Product Banner~Products~staff~user":"3f1957b5","Pd Offer Form":"5c80ec2a","Product Banner":"782523f2","staff":"51345dce","user":"a6a127af","RoleForm":"d68b2731","Role":"575fb6d1","barcode-scan":"412d0720","complain":"bfd07b90","Products":"f8df413c","chunk-42a09d46":"29832338","chunk-31aa06ca":"ca651014","login":"f74981bd","setting":"4c1e9d2b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BDA Visit":1,"Calendar~Target Upload":1,"PD Offers":1,"analytics":1,"BDA Visit Form~Pd Offer Form~Product Banner~Role~RoleForm~barcode-scan~complain~staff~user":1,"BDA Visit Form":1,"Pd Offer Form":1,"Product Banner":1,"staff":1,"user":1,"Role":1,"barcode-scan":1,"complain":1,"Products":1,"chunk-42a09d46":1,"chunk-31aa06ca":1,"login":1,"setting":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"BDA Visit":"BDA Visit","Calendar~Pd Offer Form~Product Banner~Products~Target Upload~staff~user":"Calendar~Pd Offer Form~Product Banner~Products~Target Upload~staff~user","Calendar~Target Upload":"Calendar~Target Upload","Calendar":"Calendar","Target Upload":"Target Upload","PD Offers":"PD Offers","analytics":"analytics","BDA Visit Form~Pd Offer Form~Product Banner~Role~RoleForm~barcode-scan~complain~staff~user":"BDA Visit Form~Pd Offer Form~Product Banner~Role~RoleForm~barcode-scan~complain~staff~user","BDA Visit Form":"BDA Visit Form","Pd Offer Form~Product Banner~Products~staff~user":"Pd Offer Form~Product Banner~Products~staff~user","Pd Offer Form":"Pd Offer Form","Product Banner":"Product Banner","staff":"staff","user":"user","RoleForm":"RoleForm","Role":"Role","barcode-scan":"barcode-scan","complain":"complain","Products":"Products","login":"login","setting":"setting"}[chunkId]||chunkId) + "." + {"BDA Visit":"7ac10853","Calendar~Pd Offer Form~Product Banner~Products~Target Upload~staff~user":"31d6cfe0","Calendar~Target Upload":"664eb92a","Calendar":"31d6cfe0","Target Upload":"31d6cfe0","PD Offers":"6313d2c7","analytics":"18fb1e53","chunk-2d0e97b4":"31d6cfe0","BDA Visit Form~Pd Offer Form~Product Banner~Role~RoleForm~barcode-scan~complain~staff~user":"e0b1095c","BDA Visit Form":"6875cfd4","Pd Offer Form~Product Banner~Products~staff~user":"31d6cfe0","Pd Offer Form":"6875cfd4","Product Banner":"391da3b1","staff":"c8941b1a","user":"4fc874ae","RoleForm":"31d6cfe0","Role":"dcd5f500","barcode-scan":"11ed0d49","complain":"be079bf7","Products":"440bda4a","chunk-42a09d46":"a8fbd0b3","chunk-31aa06ca":"25d77cf2","login":"82d4a81d","setting":"a6dab880"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
